<template>
  <div class="f-bt w-200">
    <div
      class="l"
      @click="goodsNumHandler('delete')"
    >
      <g-img
        src="reduce_icon"
        :size="50"
      ></g-img>
    </div>
    <div class="c ft-30 bold-900">
      {{this.goodsNum}}
    </div>
    <div
      class="r"
      @click="goodsNumHandler('add')"
    >
      <g-img
        src="add_icon_active"
        :size="50"
      ></g-img>
    </div>
  </div>
</template>

<script>
export default {
  name: "GhandleGoodsNum",
  props: {
    num: {
      type: [Number, String],
      required: true,
    },

  },
  data() {
    return {
      goodsNum: this.num,
    };
  },
  components: {

  },
  created() {

  },
  mounted() {

  },
  methods: {
    goodsNumHandler(handle) {
      if (handle === "add") {
        this.goodsNum++;
      }
      if (handle === "delete") {
        if (this.goodsNum === 1) {
          return this.$toast('购买数量不得低于1张')
        }
        this.goodsNum--;
      }
      this.$emit('update:num', this.goodsNum);
    },

  }
};
</script>
<style scoped lang='scss'>
</style>
